import { useEffect } from 'react';

type UseChatSyncProps = {
  mintlifyIsOpen: boolean;
  setMintlifyIsOpen: (isOpen: boolean) => void;
};

export const useChatSync = ({
  mintlifyIsOpen,
  setMintlifyIsOpen,
}: UseChatSyncProps) => {
  useEffect(() => {
    if (mintlifyIsOpen && window.Pylon) {
      window.Pylon('hide');
    }
  }, [mintlifyIsOpen]);

  useEffect(() => {
    let cleanupFn: (() => void) | null = null;

    const setupPylonListener = (): boolean => {
      if (!window.Pylon || typeof window.Pylon !== 'function') {
        return false;
      }

      const handlePylonShow = () => {
        setMintlifyIsOpen(false);
      };

      try {
        window.Pylon('onShow', handlePylonShow);

        if (mintlifyIsOpen) {
          window.Pylon('hide');
        }

        cleanupFn = () => {
          try {
            if (window.Pylon && typeof window.Pylon === 'function') {
              window.Pylon('off', handlePylonShow);
            }
          } catch {
            // Ignore cleanup errors
          }
        };
        return true;
      } catch {
        return false;
      }
    };

    let intervalId: NodeJS.Timeout | null = null;

    const startSetup = () => {
      if (setupPylonListener()) {
        return;
      }

      let attempts = 0;
      const maxAttempts = 100;
      intervalId = setInterval(() => {
        attempts++;
        if (setupPylonListener() || attempts >= maxAttempts) {
          if (intervalId) {
            clearInterval(intervalId);
            intervalId = null;
          }
        }
      }, 200);
    };

    startSetup();

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
      if (cleanupFn) {
        cleanupFn();
      }
    };
  }, [setMintlifyIsOpen]);
};
